<template lang="pug">
footer.footer
    p.site-name
        a(href="http://dmp.360.cn/", target="_blank") 360DMP
        | &nbsp;&nbsp;|&nbsp;&nbsp;
        a(href="http://shangyi.360.cn/", target="_blank") 360商易
        | &nbsp;&nbsp;|&nbsp;&nbsp;
        a(href="https://s4.qhimg.com/static/68681a638322a648.pdf", target="_blank") 服务协议
    p.site-copyright Copyright &copy; 360商业数据部 2005-{{year}} 360.CN All Rights Reserved 360分析 京ICP证080047号
    p.site-copyright
        a(href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11000002000006")
          img(style="vertical-align: middle;" src="http://p4.qhmsg.com/d/inn/f570feb7/ghs.png") 
          | 京公网安备 11000002000006号
</template>

<script>
export default {
    data () {
        return {
            year: (new Date()).getFullYear()
        };
    }
};
</script>



// WEBPACK FOOTER //
// footer.vue?0273dbd7